import { reactive, watch } from 'vue';
import { watchOnce } from '@vueuse/core';

import { isFeatureToggleActive } from '../customFeatureToggles';

export type StatsigExperimentName =
  | 'trip_summary_pre_checkout_experiment'
  | 'meta_customer_date_search'
  | 'hotel_card_overview_smaller'
  | 'overview_placeholder_no_transport_experiment'
  | 'alterantive_copy_for_mobile_footer'
  | 'alternative_suggested_itinerary_hotels'
  | 'remove_product_links'
  | 'peek_price_map';

export type StatsigMultiExperimentName = 'overview_shorter_hotels_carousel';

interface StatsigExperimentState {
  value: boolean;
  isLoaded: boolean;
}

interface StatsigExperimentMultiState {
  value: string;
  isLoaded: boolean;
}

type StatsigExperiments = Record<StatsigExperimentName, StatsigExperimentState>;

type StatsigMultiExperiments = Record<
  StatsigMultiExperimentName,
  StatsigExperimentMultiState
>;

const statsigExperiments = reactive<StatsigExperiments>({
  trip_summary_pre_checkout_experiment: { value: false, isLoaded: false },
  meta_customer_date_search: { value: false, isLoaded: false },
  hotel_card_overview_smaller: { value: false, isLoaded: false },
  overview_placeholder_no_transport_experiment: {
    value: false,
    isLoaded: false,
  },
  alterantive_copy_for_mobile_footer: { value: false, isLoaded: false },
  alternative_suggested_itinerary_hotels: {
    value: false,
    isLoaded: false,
  },
  remove_product_links: { value: false, isLoaded: false },
  peek_price_map: { value: false, isLoaded: false },
});

const statsigMultiExperiments = reactive<StatsigMultiExperiments>({
  overview_shorter_hotels_carousel: { value: 'control', isLoaded: false },
});

export function assignExperimentValue(
  experimentName: StatsigExperimentName,
  value: boolean
): void {
  statsigExperiments[experimentName].value = value;
  statsigExperiments[experimentName].isLoaded = true;
}
export function assignMultiExperimentValue(
  multiExperimentName: StatsigMultiExperimentName,
  value: string
): void {
  statsigMultiExperiments[multiExperimentName].value = value;
  statsigMultiExperiments[multiExperimentName].isLoaded = true;
}

export async function isExperimentAsync(
  experimentName: StatsigExperimentName
): Promise<boolean> {
  return new Promise((resolve) => {
    if (isFeatureToggleActive(experimentName)) {
      resolve(true);
    } else if (isFeatureToggleActive(`!${experimentName}`)) {
      resolve(false);
    } else if (statsigExperiments[experimentName].isLoaded) {
      resolve(statsigExperiments[experimentName].value);
    } else {
      watch(
        () => statsigExperiments[experimentName].isLoaded,
        () => resolve(statsigExperiments[experimentName].value),
        { once: true }
      );
    }
  });
}

export async function isMultiExperimentAsync(
  multiExperimentName: StatsigMultiExperimentName
): Promise<string> {
  return new Promise((resolve) => {
    if (statsigMultiExperiments[multiExperimentName].isLoaded) {
      resolve(statsigMultiExperiments[multiExperimentName].value);
    } else {
      watchOnce(
        () => statsigMultiExperiments[multiExperimentName].isLoaded,
        () => resolve(statsigMultiExperiments[multiExperimentName].value)
      );
    }
  });
}
